import ClearIcon from "~icons/fa6-solid/x";

export default function Email({
  email,
  remove,
}: {
  email: string;
  remove: () => void;
}) {
  return (
    <div className="flex gap-2 items-center bg-slate-50 border rounded-2xl px-3">
      <div className="text-slate-900">{email}</div>
      <ClearIcon
        className="cursor-pointer text-slate-400 hover:text-slate-600 size-3"
        onClick={remove}
      />
    </div>
  );
}
